const AdminAPI = {
  userList: { url: '/login', method: 'POST' },
  paymentTypeList: { url: '/get-payment-type', method: 'POST' },
  getFFLProfile: { url: '/ffl-profile', method: 'GET' },
  getAdminFFLProfile: { url: '/admin-ffl-profile', method: 'GET' },
  updateFFLProfile: { url: '/ffl-profile', method: 'PATCH' },
  connectPaymentGateway: { url: '/connect-payment-gateway', method: 'POST' },
  disconnectPaymentGateway: { url: '/disconnect-payment-gateway', method: 'POST' },
  connectShippingCarrier: { url: '/connect-shipping-carrier', method: 'POST' },
  disconnectShippingCarrier: { url: '/disconnect-shipping-carrier', method: 'POST' },
  verifyFFLLicence: { url: '/verify-FFL-license', method: 'POST' },
  pincodeInfo: { url: '/fetch-pincode-info', method: 'POST' },
  stateList: { url: '/get-states', method: 'POST' },
  // role
  roleList: { url: '/get-role', method: 'POST' },
  exportRoleData: { url: '/get-role', method: 'POST_BUFFER_DATA' },
  addRole: { url: '/role', method: 'POST' },
  singleRoleInfo: { url: '/get-role-info', method: 'POST' },
  updateRole: { url: '/role', method: 'PATCH' },
  updatRoleStatus: { url: '/update-role-status', method: 'POST' },
  updatParentRolePermission: { url: '/update-parent-role', method: 'POST' },
  // employee
  employeeList: { url: '/get-employee', method: 'POST' },
  exportEmployeeData: { url: '/get-employee', method: 'POST_BUFFER_DATA' },
  addEmployee: { url: '/employee', method: 'POST' },
  singleEmployeeInfo: { url: '/get-employee-info', method: 'POST' },
  updateEmployee: { url: '/employee', method: 'PATCH' },
  updatEmployeeStatus: { url: '/update-employee-status', method: 'POST' },
  // customer
  customerList: { url: '/get-customer', method: 'POST' },
  exportCustomerData: { url: '/get-customer', method: 'POST_BUFFER_DATA' },
  singleCustomerInfo: { url: '/get-customer-info', method: 'POST' },
  updateCustomer: { url: '/customer', method: 'PATCH' },
  deleteCustomer: { url: '/customer', method: 'DELETE' },
  bulkUpdateCustomerGroup: { url: '/bulk-update-customer-group', method: 'POST' },
  // customer group
  customerGroupList: { url: '/get-customer-group', method: 'POST' },
  exportCustomerGroupData: { url: '/get-customer-group', method: 'POST_BUFFER_DATA' },
  addCustomerGroup: { url: '/customer-group', method: 'POST' },
  updateCustomerGroup: { url: '/customer-group', method: 'PATCH' },
  deleteCustomerGroup: { url: '/customer-group', method: 'DELETE' },
  updateCustomerGroupStatus: { url: '/update-customer-group-status', method: 'POST' },
  // ffl
  fflCounter: { url: '/ffl-counter', method: 'GET' },
  fflListByProductCategory: { url: '/get-ffl-by-product-category', method: 'POST' },
  fflList: { url: '/get-ffl', method: 'POST' },
  exportFFLData: { url: '/get-ffl', method: 'POST_BUFFER_DATA' },
  singleFFLInfo: { url: '/get-ffl-info', method: 'POST' },
  updateFFL: { url: '/ffl', method: 'PATCH' },
  deleteFFL: { url: '/ffl', method: 'DELETE' },
  verifyFFL: { url: '/ffl-verification', method: 'POST' },
  // table setting
  updateTableSettings: { url: '/update-table-settings', method: 'POST' },
  // ffl fastbound
  getFFLFastBoundSetting: { url: '/get-fast-bound-setting', method: 'POST' },
  updateFFLFastBound: { url: '/fast-bound-setting', method: 'POST' },
  // album images
  uploadAlbumimages: { url: '/album-images', method: 'POST' },
  deleteAlbumimages: { url: '/album-images', method: 'DELETE' },
  // category
  categoryList: { url: '/get-category', method: 'POST' },
  allCategoryList: { url: '/get-all-category', method: 'POST' },
  exportCategoryData: { url: '/get-category', method: 'POST_BUFFER_DATA' },
  addCategory: { url: '/category', method: 'POST' },
  singleCategoryInfo: { url: '/get-category-info', method: 'POST' },
  updateCategory: { url: '/category', method: 'PATCH' },
  updateCategoryStatus: { url: '/update-category-status', method: 'POST' },
  updateCategoryFeatured: { url: '/update-category-featured', method: 'POST' },
  updateCategoryOrder: { url: '/update-category-order', method: 'POST' },
  deleteCategory: { url: '/category', method: 'DELETE' },
  // Product
  productCounter: { url: '/product-counter', method: 'GET' },
  getOptionCategories: { url: '/get-option-categories', method: 'GET' },
  productList: { url: '/get-product', method: 'POST' },
  exportProductData: { url: '/get-product', method: 'POST_BUFFER_DATA' },
  addProduct: { url: '/product', method: 'POST' },
  importProduct: { url: '/import-products', method: 'POSTFORMDATA_STREAM' },
  singleProductInfo: { url: '/get-product-info', method: 'POST' },
  updateProduct: { url: '/product', method: 'PATCH' },
  updateProductStatus: { url: '/update-product-status', method: 'POST' },
  bulkUpdateProductStatus: { url: '/bulk-update-product-status', method: 'POST' },
  deleteProduct: { url: '/product', method: 'DELETE' },
  getSampleProductCsv: { url: '/get-sample-product-csv', method: 'POST_BUFFER_DATA' },
  // order
  orderList: { url: '/get-order', method: 'POST' },
  orderGroupedList: { url: '/get-grouped-order', method: 'POST' },
  exportOrderData: { url: '/get-order-item', method: 'POST_BUFFER_DATA' },
  singleOrderInfo: { url: '/get-order-info', method: 'POST' },
  orderInfoByOrderNumber: { url: '/get-order-info-by-order-number', method: 'POST' },
  orderItemByOrderNumber: { url: '/order-items-by-order-number', method: 'POST' },
  orderCounter: { url: '/order-counter', method: 'GET' },
  downloadOrderItemPurchaseFormPDF: {
    url: '/order-item-purchase-form-pdf',
    method: 'POST_BUFFER_DATA',
  },
  orderSummaryPdf: { url: '/order-summary-pdf', method: 'POST_BUFFER_DATA' },
  updateOrderStatus: { url: '/change-order-status', method: 'POST' },
  updateOrderNotes: { url: '/update-order-notes', method: 'POST' },
  updateOrderItemTracking: { url: '/update-order-item-tracking', method: 'POST' },
  exportOrderDetailData: { url: '/export-order-detail', method: 'POST_BUFFER_DATA' },
  createOrderReport: { url: '/order-report', method: 'POST' },
  createProductHelpRequest: { url: '/product-help-request', method: 'POST' },
  approveReportRequest: { url: '/approve-report-request', method: 'POST' },
  rejectReportRequest: { url: '/reject-report-request', method: 'POST' },
  sendIntegrationRequest: { url: '/integration-request', method: 'POST' },
  // Reviews
  fflReviewCounter: { url: '/ffl-review-counter', method: 'GET' },
  fflReviewList: { url: '/get-ffl-review', method: 'POST' },
  fflReviewInfo: { url: '/get-ffl-review-info', method: 'POST' },
  submitFFLReviewReply: { url: '/submit-ffl-review-reply', method: 'POST' },
  updateFFLReviewStatus: { url: '/update-ffl-review-status', method: 'POST' },
  deleteFFLReview: { url: '/ffl-review', method: 'DELETE' },
  exportFFLReviewData: { url: '/get-ffl-review', method: 'POST_BUFFER_DATA' },

  // Product Review
  productReviewCounter: { url: '/product-review-counter', method: 'GET' },
  productReviewList: { url: '/get-product-review', method: 'POST' },
  productReviewInfo: { url: '/get-product-review-info', method: 'POST' },
  submitProductReviewReply: { url: '/submit-product-review-reply', method: 'POST' },
  updateProductReviewStatus: { url: '/update-product-review-status', method: 'POST' },
  exportProductReviewData: { url: '/get-product-review', method: 'POST_BUFFER_DATA' },
  deleteProductReview: { url: '/product-review', method: 'DELETE' },

  // Message
  adminMessageList: { url: '/get-message', method: 'POST' },
  exportMessageData: { url: '/get-message', method: 'POST_BUFFER_DATA' },
  notificationList: { url: '/get-notification', method: 'POST' },
  sendMessage: { url: '/message', method: 'POST' },
  singleMessageInfo: { url: '/get-message-info', method: 'POST' },
  singleNotificationInfo: { url: '/notification-info', method: 'POST' },
  // Email Template
  emailTemplateList: { url: '/get-email-template', method: 'POST' },
  updateEmailTemplateStatus: { url: '/update-email-template-status', method: 'POST' },
  emailTemplateVariableList: { url: '/get-email-variable', method: 'POST' },
  singleEmailTemplateInfo: { url: '/get-email-template-info', method: 'POST' },
  updateEmailTemplate: { url: '/email-template', method: 'PATCH' },
  previewEmailTemplate: { url: '/email-template-preview', method: 'POST' },
  // SMS Template
  smsTemplateList: { url: '/get-sms-template', method: 'POST' },
  updateSMSTemplateStatus: { url: '/update-sms-template-status', method: 'POST' },
  smsTemplateVariableList: { url: '/get-sms-variable', method: 'POST' },
  singleSMSTemplateInfo: { url: '/get-sms-template-info', method: 'POST' },
  updateSMSTemplate: { url: '/sms-template', method: 'PATCH' },
  previewSMSTemplate: { url: '/sms-template-preview', method: 'POST' },
  // Subscription Plan List
  subscriptionPlanFeatureList: { url: '/get-subscription-feature', method: 'POST' },
  subscriptionPlanTypeList: { url: '/get-subscription-type', method: 'POST' },
  subscriptionPlanList: { url: '/get-subscription', method: 'POST' },
  exportSubscriptionPlanData: { url: '/get-subscription', method: 'POST_BUFFER_DATA' },
  addSubscriptionPlan: { url: '/subscription', method: 'POST' },
  singleSubscriptionPlanInfo: { url: '/get-subscription-info', method: 'POST' },
  updateSubscriptionPlan: { url: '/subscription', method: 'PATCH' },
  updateSubscriptionPlanStatus: { url: '/update-subscription-status', method: 'POST' },
  // blog
  blogCounter: { url: '/blog-counter', method: 'GET' },
  blogList: { url: '/get-blog', method: 'POST' },
  singleBlogInfo: { url: '/get-blog-info', method: 'POST' },
  addBlog: { url: '/blog', method: 'POST' },
  updateBlog: { url: '/blog', method: 'PATCH' },
  deleteBlog: { url: '/blog', method: 'DELETE' },
  exportBlogData: { url: '/get-blog', method: 'POST_BUFFER_DATA' },
  updateBlogFeatured: { url: '/update-blog-featured', method: 'POST' },
  updateBlogStatus: { url: '/update-blog-status', method: 'POST' },
  blogAuthorList: { url: '/get-blog-authors', method: 'POST' },
  bulkUpdateBlogStatus: { url: '/bulk-update-blog-status', method: 'POST' },
  bulkDeleteBlog: { url: '/bulk-delete-blog', method: 'POST' },
  // blog category
  blogCategoryList: { url: '/get-blog-category', method: 'POST' },
  exportBlogCategoryData: { url: '/get-blog-category', method: 'POST_BUFFER_DATA' },
  addBlogCategory: { url: '/blog-category', method: 'POST' },
  updateBlogCategory: { url: '/blog-category', method: 'PATCH' },
  deleteBlogCategory: { url: '/blog-category', method: 'DELETE' },
  updateBlogCategoryStatus: { url: '/update-blog-category-status', method: 'POST' },

  // product attribute
  deleteProductAttribute: { url: '/product-attribute', method: 'DELETE' },
  singleProductAttribute: { url: '/get-product-attribute-info', method: 'POST' },
  productAttributeList: { url: '/get-product-attribute', method: 'POST' },
  exportProductAttributeData: { url: '/get-product-attribute', method: 'POST_BUFFER_DATA' },
  addProductAttribute: { url: '/product-attribute', method: 'POST' },
  updateProductAttribute: { url: '/product-attribute', method: 'PATCH' },
  updateProductAttributeStatus: { url: '/update-product-attribute-status', method: 'POST' },
  updateProductAttributeFilterableStatus: {
    url: '/update-product-attribute-filterable-status',
    method: 'POST',
  },
  getProductAttributeByCategory: { url: '/get-attribute-from-category', method: 'POST' },
  // advertisement
  advertisementList: { url: '/get-advertisement', method: 'POST' },
  singleAdvertisementInfo: { url: '/get-advertisement-info', method: 'POST' },
  addAdvertisement: { url: '/advertisement', method: 'POST' },
  updateAdvertisement: { url: '/advertisement', method: 'PATCH' },
  deleteAdvertisement: { url: '/advertisement', method: 'DELETE' },
  exportAdvertisementData: { url: '', method: 'POST_BUFFER_DATA' },
  updateAdvertisementStatus: { url: '/update-advertisement-status', method: 'POST' },
  // url Rewrite
  urlRewriteList: { url: '/get-url-rewrite', method: 'POST' },
  exportURLRewriteData: { url: '/get-url-rewrite', method: 'POST_BUFFER_DATA' },
  addURLRewrite: { url: '/url-rewrite', method: 'POST' },
  singleURLRewriteInfo: { url: '/get-url-rewrite-info', method: 'POST' },
  updateURLRewrite: { url: '/url-rewrite', method: 'PATCH' },
  deleteURLRewrite: { url: '/url-rewrite', method: 'DELETE' },
  // content pages
  contentPagesList: { url: '/get-content-page', method: 'POST' },
  singleContentPageInfo: { url: '/get-content-page-info', method: 'POST' },
  addContentPage: { url: '/content-page', method: 'POST' },
  updateContentPage: { url: '/content-page', method: 'PATCH' },
  deleteContentPage: { url: '/content-page', method: 'DELETE' },
  updateContentPageStatus: { url: '/update-content-page-status', method: 'POST' },
  contentPageTypes: { url: '/get-content-page-types', method: 'POST' },
  // advertisement location
  advertisementLocationList: { url: '/get-all-advertisement-placements', method: 'POST' },
  singleAdvertisementLocationInfo: { url: '/', method: 'POST' },
  updateAdvertisementLocation: { url: '/assign-advertisement', method: 'POST' },
  deleteAdvertisementLocation: { url: '/assign-advertisement', method: 'DELETE' },

  // guns for sale
  gunCounter: { url: '/gun-for-sale-counter', method: 'GET' },
  gunsForSaleList: { url: '/get-gun-for-sale', method: 'POST' },
  singleGunForSaleInfo: { url: '/get-gun-for-sale-info', method: 'POST' },
  updateGunStatus: { url: '/update-gun-for-sale-status', method: 'POST' },
  exportGunData: { url: '/get-gun-for-sale', method: 'POST_BUFFER_DATA' },
  downloadGunPdf: { url: '/gun-for-sale-pdf', method: 'POST_BUFFER_DATA' },
  markGunSold: { url: '/gun-for-sale-mark-as-sold', method: 'POST' },
  getGunForSaleLogs: { url: '/get-gun-for-sale-logs', method: 'POST' },

  // purchase forms
  purchaseFormsList: { url: '/get-purchase-form', method: 'POST' },
  singlePurchaseFormsInfo: { url: '/get-purchase-form-info', method: 'POST' },
  exportPurchaseFormsData: { url: '/get-purchase-form', method: 'POST_BUFFER_DATA' },
  downloadPurchaseFormsPdf: { url: '/purchase-form-pdf', method: 'POST_BUFFER_DATA' },
  // affiliate code
  getAffiliateCodeInfo: { url: '/get-affiliate-code-info', method: 'POST' },
  updateAffiliateCodeDetails: { url: '/affiliate-code', method: 'PATCH' },
  createAffiliateCodeDetails: { url: '/affiliate-code', method: 'POST' },
  getAllAffiliateCodes: { url: '/get-affiliate-code', method: 'POST' },
  exportAffiliateData: { url: '/get-affiliate-code', method: 'POST_BUFFER_DATA' },
  deleteAffiliateCode: { url: '/affiliate-code', method: 'DELETE' },
  getAffiliateAnalyticsSummary: { url: '/get-affiliate-analytics-summary', method: 'POST' },
  getAffiliateAnalysisList: { url: '/get-affiliate-analysis-list', method: 'POST' },
  exportAffiliateAnalysisData: { url: '/get-affiliate-analysis-list', method: 'POST_BUFFER_DATA' },
  // coupons
  couponCounter: { url: '/coupon-counter', method: 'GET' },
  couponList: { url: '/get-coupon-code', method: 'POST' },
  addCoupon: { url: '/coupon-code', method: 'POST' },
  updateCoupon: { url: '/coupon-code', method: 'PATCH' },
  deleteCoupon: { url: '/coupon-code', method: 'DELETE' },
  singleCouponInfo: { url: '/get-coupon-code-info', method: 'POST' },
  updateCouponStatus: { url: '/update-coupon-status', method: 'POST' },
  exportCouponData: { url: '/get-coupon-code', method: 'POST_BUFFER_DATA' },

  // Dashboard
  getDashboardCounts: { url: '/get-dashboard-counts', method: 'POST' },
  // General Setting
  generalSettingList: { url: '/get-all-settings', method: 'POST' },
  exportGeneralSettingData: { url: '/get-all-settings', method: 'POST_BUFFER_DATA' },
  updateGeneralSettingDetails: { url: '/update-setting', method: 'POST' },
  createGeneralSettingDetails: { url: '/create-setting', method: 'POST' },

  // Global Search
  globalSearch: { url: '/global-search', method: 'POST' },
  // notifications
  notificationsList: { url: '/get-notification', method: 'POST' },
  notificationsInfo: { url: '/notification-info', method: 'POST' },
  // sidebar badges
  moduleBadgeCounts: { url: '/get-module-badge-counts', method: 'POST' },
  markModuleViewed: { url: '/mark-module-viewed', method: 'POST' },
  markAllNotificationsRead: { url: '/mark-all-notifications-read', method: 'POST' },

  // transfer request
  transferRequestList: { url: '/get-transfer-requests', method: 'POST' },
  updateTransferRequest: { url: '/', method: 'PATCH' },
  singleTransferRequestInfo: { url: '/', method: 'POST' },
  exportTransferRequestData: { url: '/get-transfer-requests', method: 'POST_BUFFER_DATA' },
  changeTransferRequestStatus: { url: '/update-transfer-request-status', method: 'POST' },
  markTransferItemReadyForPickup: { url: '/mark-transfer-item-ready-for-pickup', method: 'POST' },
  transferRequestFflOptions: { url: '/get-transfer-request-ffl-options', method: 'POST' },
  // a declined transfer's item sent to another FFL (customer, admin or selling FFL)
  resendTransferRequest: { url: '/resend-transfer-request', method: 'POST' },

  // manufacturer
  manufacturerList: { url: '/get-manufacturer', method: 'POST' },
  exportManufacturerData: { url: '/get-manufacturer', method: 'POST_BUFFER_DATA' },
  addManufacturer: { url: '/manufacturer', method: 'POST' },
  singleManufacturerInfo: { url: '/get-manufacturer-info', method: 'POST' },
  updateManufacturer: { url: '/manufacturer', method: 'PATCH' },
  updateManufacturerStatus: { url: '/update-manufacturer-status', method: 'POST' },
  deleteManufacturer: { url: '/manufacturer', method: 'DELETE' },

  // banner
  bannerList: { url: '/get-banner', method: 'POST' },
  allBannerList: { url: '/get-all-banner', method: 'POST' },
  exportBannerData: { url: '/get-banner', method: 'POST_BUFFER_DATA' },
  addBanner: { url: '/banner', method: 'POST' },
  singleBannerInfo: { url: '/get-banner-info', method: 'POST' },
  updateBanner: { url: '/banner', method: 'PATCH' },
  updateBannerOrder: { url: '/update-banner-order', method: 'POST' },
  updateBannerStatus: { url: '/update-banner-status', method: 'POST' },
  deleteBanner: { url: '/banner', method: 'DELETE' },

  // transaction
  transactionList: { url: '/get-transaction', method: 'POST' },
  transactionGroupedList: { url: '/get-grouped-transaction', method: 'POST' },
  transactionInfo: { url: '/get-transaction-info', method: 'POST' },
  exportTransactionData: { url: '/get-transaction', method: 'POST_BUFFER_DATA' },

  // order report
  orderReportList: { url: '/get-order-reports', method: 'POST' },
  exportOrderReportData: { url: '/get-order-reports', method: 'POST_BUFFER_DATA' },
  // sms log
  smsLogList: { url: '/get-sms-log', method: 'POST' },
  exportSmsLogData: { url: '/get-sms-log', method: 'POST_BUFFER_DATA' },
  // search terms
  searchTermsList: { url: '/get-search-terms', method: 'POST' },
  exportSearchTermsData: { url: '/get-search-terms', method: 'POST_BUFFER_DATA' },
  // FAQ
  faqList: { url: '/get-faq', method: 'POST' },
  exportFaqData: { url: '/get-faq', method: 'POST_BUFFER_DATA' },
  addFaq: { url: '/faq', method: 'POST' },
  singleFaqInfo: { url: '/get-faq-info', method: 'POST' },
  updateFaq: { url: '/faq', method: 'PATCH' },
  updateFaqStatus: { url: '/update-faq-status', method: 'POST' },
  deleteFaq: { url: '/faq', method: 'DELETE' },
  // Dynamic Modules
  dynamicModules: { url: '/dynamic-modules', method: 'GET' },
  dynamicList: { url: '/dynamic/:moduleName/list', method: 'POST' },
  dynamicCreate: { url: '/dynamic/:moduleName/create', method: 'POST' },
  dynamicUpdate: { url: '/dynamic/:moduleName/update', method: 'PATCH' },
  dynamicDelete: { url: '/dynamic/:moduleName/delete', method: 'DELETE' },
  dynamicStatus: { url: '/dynamic/:moduleName/status', method: 'POST' },
  dynamicInfo: { url: '/dynamic/:moduleName/info', method: 'POST' },

  // Caliber
  caliberList: { url: '/get-calibers', method: 'GET' },
  barrelLengthList: { url: '/get-barrel-lengths', method: 'GET' },
  actionTypeList: { url: '/get-action-types', method: 'GET' },

  // shipping configuration
  shippingConfigurationList: { url: '/get-ffl-shipping-carrier', method: 'POST' },
  addShippingConfiguration: { url: '/ffl-shipping-carrier', method: 'POST' },
  singleShippingConfigurationInfo: { url: '/get-ffl-shipping-carrier-info', method: 'POST' },
  updateShippingConfiguration: { url: '/ffl-shipping-carrier', method: 'PATCH' },
  deleteShippingConfiguration: { url: '/ffl-shipping-carrier', method: 'DELETE' },
  updateShippingConfigurationStatus: { url: '/update-ffl-shipping-carrier-status', method: 'POST' },
  // carrier
  shippingCarrierList: { url: '/get-shipping-carrier', method: 'POST' },
  calculateEstimatedShipping: { url: '/calculate-estimated-shipping', method: 'POST' },
  trackShippingPackage: { url: '/track-shipping-package', method: 'POST' },
  // handling time
  handlingTimeList: { url: '/get-handling-times', method: 'GET' },
  getFFLHandlingTime: { url: '/get-ffl-handling-time', method: 'POST' },
  updateFFLHandlingTime: { url: '/ffl-handling-time', method: 'POST' },
  // free shipping rule
  fflFreeShippingRuleList: { url: '/get-ffl-free-shipping-rule', method: 'POST' },
  addFFLFreeShippingRule: { url: '/ffl-free-shipping-rule', method: 'POST' },
  singleFFLFreeShippingRuleInfo: { url: '/get-ffl-free-shipping-rule-info', method: 'POST' },
  updateFFLFreeShippingRule: { url: '/ffl-free-shipping-rule', method: 'PATCH' },
  deleteFFLFreeShippingRule: { url: '/ffl-free-shipping-rule', method: 'DELETE' },
  updateFFLFreeShippingRuleStatus: { url: '/update-ffl-free-shipping-rule-status', method: 'POST' },
  inviteFFL: { url: '/invite-ffl', method: 'POST' },
  inviteCustomer: { url: '/invite-customer', method: 'POST' },

  // order item return & cancellation requests
  orderItemCancellationRequests: { url: '/get-order-item-cancellation-requests', method: 'POST' },
  orderItemCancellationRequestInfo: {
    url: '/get-order-item-cancellation-request-info',
    method: 'POST',
  },
  approveReturnRequest: { url: '/approve-return-request', method: 'POST' },
  rejectReturnRequest: { url: '/reject-return-request', method: 'POST' },
  updateOrderItemReturnStatus: { url: '/update-order-item-return-status', method: 'POST' },
};
export default AdminAPI;
